import { Component, OnInit, OnDestroy } from '@angular/core';
import { MessageService } from 'primeng/api';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CategoryService } from '../../../services/category.service';
import { ViewChild } from '@angular/core';
import { FileUpload } from 'primeng/fileupload';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ImageCroppedEvent, ImageTransform } from 'ngx-image-cropper';

@Component({
    selector: 'app-category-add',
    templateUrl: './add.component.html',
    styleUrls: ['./add.component.scss'],
    providers: [MessageService]
})

export class SubcategoryAddComponent implements OnInit, OnDestroy {

    private destroy$ = new Subject<void>();
    categoryForm: FormGroup;
    errorMessage = '';
    submitted = false;
    uploadedFiles: any[] = [];
    categorystatus: any;
    parentcategory: any;
    parentcategorycode: any;
    statuses: any = [];

    public uploadedpic;
    public showUploadedpic = false;
    categorylist: any = [];
    @ViewChild('fileUpload') fileUpload!: FileUpload;
    imageChangedEvent: any = '';
    croppedImage: any = '';
    cropDialog: boolean = false;
    selectedFile: File | null = null;
    imageSize = 1000000;
    croppedImageMaxSize = 1000000;
    croppedImageSize = 0;
    croppedImageError: string | null = null;
    scale = 1;
    transform: ImageTransform = {};
    cropApplied = false;
    previousLogoImage: any = null;
    previousUploadedFiles: any[] = [];

    constructor(private categoryService: CategoryService, private formBuilder: FormBuilder, private messageService: MessageService,
        private router: Router) { }

    ngOnInit(): void {
        this.statuses = [
            { label: 'Active', value: true },
            { label: 'In-Active', value: false }
        ];
        this.categoryForm = this.formBuilder.group({
            name: ['', [Validators.required, Validators.pattern('^[A-Za-z0-9 ]*$')]],
            description: [''],
            status: [{ label: 'Active', value: true }],
            parent_category: ['', Validators.required],
            disable: [false],
            default_data: [false],
        });
        this.categorystatus = true;
        this.getAllCategory();
    }

    getAllCategory() {
        var query;
        query = "filterByStatus=true";
        this.categoryService.getAllCategory(query).pipe(takeUntil(this.destroy$)).subscribe(
            data => {
                this.categorylist = data.data.items;
            },
            err => {
                this.errorMessage = err.error.message;
            }
        );
    }

    // convenience getter for easy access to form fields
    get f() {
        return this.categoryForm.controls;
    }

    onFileSelect(event: any) {
        const file = event.files[0];
        if (!file) return;
        if (file.size > this.imageSize) {
            this.rejectOversizedImage();
            return;
        }
        this.croppedImageError = null;
        this.croppedImageSize = 0;
        this.selectedFile = file;
        const fileEvent: any = {
            target: {
                files: [file]
            }
        };
        this.imageChangedEvent = fileEvent;
        this.cropDialog = true;
    }

    // imageCropped(event: ImageCroppedEvent) {
    //     this.croppedImage = event.base64;
    //     this.croppedImageSize = this.getBase64SizeBytes(this.croppedImage);
    //     this.croppedImageError = this.croppedImageSize > this.croppedImageMaxSize
    //         ? 'Cropped image size must be less than 1 MB.'
    //         : null;
    // }

    getBase64SizeBytes(base64: string): number {
        if (!base64) return 0;
        return Math.round(
            (base64.length * (3 / 4)) -
            (base64.split(',')[0].length + 1)
        );
    }

    applyCrop() {
        if (this.croppedImageError) return;
        const file = this.base64ToFile(
            this.croppedImage,
            this.selectedFile?.name || 'image.png'
        );
        if (file.size > this.croppedImageMaxSize) {
            this.croppedImageError = 'Cropped image size must be less than 1 MB.';
            return;
        }
        this.fileUpload.clear();
        const event = {
            files: [file]
        };
        this.picUploader(event);
        this.fileUpload.files = [file];
        this.cropApplied = true;

        this.cropDialog = false;
    }

    onCropCancel() {
        this.cropDialog = false;
        this.imageChangedEvent = null;
        this.croppedImage = null;
        this.croppedImageError = null;
        this.croppedImageSize = 0;
        this.selectedFile = null;
        if (this.fileUpload) {
            this.fileUpload.clear();
        }
        this.uploadedFiles = [];
        this.uploadedpic = null;
    }

    rejectOversizedImage() {
        this.messageService.add({ key: 'toastmsg', severity: 'error', summary: 'File Too Large', detail: 'Please upload an image smaller than 1 MB', life: 6000 });
        this.restorePreviousLogo();
        this.resetCropState();
    }

    base64ToFile(data: string, filename: string): File {
        const arr = data.split(',');
        const mime = arr[0].match(/:(.*?);/)[1];
        const bstr = atob(arr[1]);
        let n = bstr.length;
        const u8arr = new Uint8Array(n);
        while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
        }
        return new File([u8arr], filename, { type: mime });
    }

    picUploader(event) {
        for (let file of event.files) {
            this.uploadedFiles.push(file);
            var reader = new FileReader();
            reader.readAsDataURL(this.uploadedFiles[0]);
            reader.onload = () => { // called once readAsDataURL is completed
                this.uploadedpic = reader.result;
                   this.showUploadedpic = true;
            }
        }
    }

    removeFile(event) {
        this.uploadedFiles = [];
        this.uploadedpic = null;
    }

    onSubmit() {
        this.submitted = true;
        // stop here if form is invalid
        if (this.categoryForm.invalid) {
            return;
        }
        var categoryData = this.categoryForm.value;
        categoryData['status'] = this.categorystatus;
        categoryData['parentcategorycode'] = this.parentcategorycode;
        categoryData['parent_category'] = this.parentcategory;
        categoryData['categoryImage'] = this.uploadedpic;
        // display form values on success
        //alert('SUCCESS!! :-)\n\n' + JSON.stringify(this.categoryForm.value, null, 4));
        //return;
        categoryData = JSON.stringify(categoryData, null, 4);
        this.categoryService.addCategory(categoryData).pipe(takeUntil(this.destroy$)).subscribe(
            data => {
                this.messageService.add({ key: 'toastmsg', severity: 'success', summary: 'Successful', detail: 'Sub Category Added', life: 6000 });
                setTimeout(() => {
                    this.router.navigate(['/manage/category/subcategory']);
                }, 1000);
            },
            ((err) => {
                this.messageService.add({ key: 'toastmsg', severity: 'error', summary: err.error.message, detail: 'Add Sub Category failed', life: 6000 });
            })
        );
    }

    onStatusSelect(event) {
        if (event) {
            this.categorystatus = event.value;
        }
    }

    onParentSelect(event) {
        if (event) {
            this.parentcategory = event.name;
            this.parentcategorycode = event.code;
        }
    }

    onReset() {
        this.submitted = false;
        this.categoryForm.reset();
    }

    backLink() {
        this.router.navigate(['/manage/category/subcategory']);
    }
    get cropDialogTitle(): string {
        return 'Crop & Adjust Add Category';
    }

    get cropDialogSubtitle(): string {
        return 'Position and scale image to fit mandatory 300 x 300 dimensions';
    }

    get cropPreviewLabel(): string {
        return '300 x 300 px';
    }

    zoomIn() {
        this.scale += 0.1;
        this.transform = {
            ...this.transform,
            scale: this.scale
        };
    }

    zoomOut() {
        if (this.scale > 0.2) {
            this.scale -= 0.1;
            this.transform = {
                ...this.transform,
                scale: this.scale
            };
        }
    }

    resetZoom() {
        this.scale = 1;
        this.transform = {
            ...this.transform,
            scale: 1
        };
    }

    imageCropped(event: ImageCroppedEvent) {
        this.croppedImage = event.base64;
        this.croppedImageSize = this.getBase64SizeBytes(this.croppedImage);
        this.croppedImageError = this.croppedImageSize > this.croppedImageMaxSize
            ? 'Cropped image size must be less than 1 MB.'
            : null;
    }

    onDialogHide() {
        if (!this.cropApplied) {
            this.restorePreviousLogo();
        }
        this.resetCropState();
    }

    private restorePreviousLogo() {
        this.uploadedpic = this.previousLogoImage;
        this.uploadedFiles = [...this.previousUploadedFiles];

        if (this.fileUpload) {
            this.fileUpload.clear();
            this.fileUpload.files = [...this.previousUploadedFiles];
        }
    }

    private resetCropState() {
        this.imageChangedEvent = null;
        this.croppedImage = null;
        this.croppedImageError = null;
        this.croppedImageSize = 0;
        this.selectedFile = null;
        this.previousLogoImage = null;
        this.previousUploadedFiles = [];
        this.cropApplied = false;
        this.resetZoom();
    }




    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
    }
}
